import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;
export const Step2HeadResult = styled.div`
  font-size: ${({ theme }) => theme.fs.xxs};
`;
export const Step2DateBox = styled.div<{ $active }>`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: 13px;
  background: ${({ theme }) => theme.palette.boxBackgroundLight};
  padding: ${({ theme }) => theme.spacing.x3};
  text-align: center;
  color: ${({ theme }) => theme.palette.primary99};
  font-size: ${({ theme }) => theme.fs.xxs};
  min-height: ${({ theme }) => theme.spacing.x13};
  &::after {
    content: '';
    width: ${({ theme }) => theme.spacing.x4};
    height: ${({ theme }) => theme.spacing.x4};
    display: flex;
    position: absolute;
    background: ${({ theme }) => theme.palette.gray80};
    bottom: -4px;
    left: 50%;
    transform: translate(-50%, 0) rotate(45deg);
  }
  ${({ $active }) =>
    $active
      ? css`
          background: ${({ theme }) => theme.palette.gray80};
          color: ${({ theme }) => theme.palette.white};
          position: relative;
        `
      : null}
`;
